import { Link } from "react-router-dom";
import { Dices, Swords, Sparkles, ScrollText } from "lucide-react";
import { ASSETS } from "../assets";
import { Reveal } from "./Reveal";

const POINTS = [
  { icon: Dices, t: "Zkoušky vlastností a dovedností" },
  { icon: Swords, t: "Boj s iniciativou a hody kostkou" },
  { icon: Sparkles, t: "Kouzla, schopnosti, short resty a další" },
  { icon: ScrollText, t: "Vlastní příkazy a záznam postavy" },
];

export const DiceSystem = () => {
  return (
    <section
      className="relative scroll-mt-20 px-6 py-16 lg:py-24"
      data-testid="dice-system-section"
    >
      <div className="mx-auto grid max-w-[1584px] items-center gap-10 rounded-xl border border-white/10 bg-[#17171b] p-8 sm:p-12 lg:grid-cols-2 lg:gap-16 lg:p-16">
        <Reveal>
          <p className="font-display text-xs font-600 uppercase tracking-[0.3em] text-[#F0801F]">
            Systém D&D 5E
          </p>
          <h2 className="mt-3 font-display text-3xl font-700 uppercase tracking-tight text-white sm:text-5xl">
            Házej. Hraj. Pamatuj.
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-white/60">
            Používáme pravidla D&D 5E pro všechny důležité akce, včetně roleplay
            boje.
          </p>
          <ul className="mt-8 space-y-4">
            {POINTS.map((p) => {
              const Icon = p.icon;
              return (
                <li key={p.t} className="flex items-center gap-4">
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-md border border-[#F0801F]/30 text-[#F0801F]">
                    <Icon className="h-4 w-4" strokeWidth={1.6} />
                  </span>
                  <span className="text-sm text-white/75">{p.t}</span>
                </li>
              );
            })}
          </ul>
          <Link
            to="/pravidla"
            data-testid="rules-overview-btn"
            className="mt-9 inline-flex items-center gap-2 rounded-md border border-white/20 px-6 py-3 font-display text-sm font-600 uppercase tracking-[0.12em] text-white transition-colors hover:border-[#F0801F] hover:text-[#F0801F]"
          >
            Přehled pravidel
          </Link>
        </Reveal>

        <Reveal delay={0.15} className="overflow-hidden rounded-xl border border-white/10">
          <img
            src={ASSETS.diceBook}
            alt="Drak a kostka d20 nad scenérií z WoW - RolePlay server s pravidly D&D 5E"
            loading="lazy"
            width={1264}
            height={711}
            className="h-full max-h-[420px] w-full object-cover"
          />
        </Reveal>
      </div>
    </section>
  );
};
